import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const ButtonStyled = styled(Button)(({ customType, theme }) => ({
  textAlign: "center",
  backgroundColor:
    customType === "regular" || customType === "outlined"
      ? "transparent"
      : "#0F110C",
  fontSize: "12px",
  color:
    customType === "regular" || customType === "outlined"
      ? "#0F110C"
      : "#EDEDED",
  border:
    customType === "outlined"
      ? `1px solid #CBCBBC`
      : customType === "contained"
      ? "1px solid #FAFAFA"
      : "none",
  borderBottom: customType === "normal" ? `1px solid #CBCBCB` : "auto",
  borderRadius:
    customType === "contained" || customType === "outlined" ? "8px" : "0px",
  width: "100%",
  padding:
    customType === "contained"
      ? "8px 16px"
      : customType === "normal"
      ? "8px 0"
      : 0,
  minWidth: "fit-content",
  display: "flex",
  gap: "8px",
  alignItems: "center",
  "&:active": {
    outline: "none",
  },
  "&:focus": {
    outline: "none",
  },
  "&:hover": {
    color: "#0197f6",
    borderColor: "#0197f6",
    backgroundColor: customType === "regular" && "transparent",
    svg: {
      transition: ".3s",
      fill: "#0197f6 !important",
    },
  },
  "&.Mui-disabled": {
    backgroundColor: customType !== "regular" && theme.palette.grey[2],
    color: theme.palette.neutral.white,
    border: "1px solid transparent",
  },
}));
